// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from ProductDeliveryInfo.module.scss  */
/* stylelint-disable */
/* stylelint-enable */
.ProductDeliveryInfo-module-Text_29s {
  font-size: 14px;
  font-weight: normal;
  line-height: 21px;
  color: var(--color-control-label); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Product/DeliveryInfo/ProductDeliveryInfo.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD,sBAAsB;AACtB,qBAAqB;AACrB;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC,EAAE","sourcesContent":["/*  imported from ProductDeliveryInfo.module.scss  */\n/* stylelint-disable */\n/* stylelint-enable */\n.ProductDeliveryInfo-module-Text_29s {\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 21px;\n  color: var(--color-control-label); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
